import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { AuthStatePersistenceService, BaseSiteService, TranslationService } from '@spartacus/core';
import { SearchBoxComponent } from '@spartacus/storefront';
import { Subject } from 'rxjs';
import { EnvironmentService } from '../../services/environment.service';
import { GgSearchBoxComponentService } from '../../services/gg-search-box-component.service';

@Component({
  selector: 'cx-searchbox',
  templateUrl: 'search-box.component.html',
  styleUrls: ['search-box.component.scss'],
  standalone: false,
})
export class HisenseSearchBoxComponent extends SearchBoxComponent implements OnInit, OnDestroy {
  private ggSearchBoxComponentService = inject(GgSearchBoxComponentService);
  private baseSiteService = inject(BaseSiteService);
  private environmentService = inject(EnvironmentService);
  private authStatePersistenceService = inject(AuthStatePersistenceService);
  private destroy$ = new Subject<void>();
  private translation = inject(TranslationService);

  showPrice!: boolean;
  suggestionsShownFirstTimeBeforeEventDispatch: boolean = false;
  suggestionsShownEventDispatched: boolean = false;
  userLoggedIn: boolean = this.authStatePersistenceService.isUserLoggedIn();

  override ngOnInit(): void {
    super.ngOnInit();

    this.baseSiteService.getActive().subscribe((active) => {
      this.showPrice = this.environmentService.getCurrentEnvironment().eShop.showPrice[active];
    });
  }

  /**
   * Closes the searchBox and opens the search result page.
   */
  override search(query: string): void {
    this.searchBoxComponentService.search(query, this.config);

    // dispatch GA4 search view auto-complete results event
    if (
      query.length >= 3 &&
      !this.suggestionsShownFirstTimeBeforeEventDispatch &&
      !this.suggestionsShownEventDispatched
    ) {
      this.suggestionsShownFirstTimeBeforeEventDispatch = true;

      setTimeout(() => {
        if (this.suggestionsShownFirstTimeBeforeEventDispatch) {
          this.ggSearchBoxComponentService.dispatchGa4GgSearchViewAutoCompleteResultsEvent();
          this.suggestionsShownFirstTimeBeforeEventDispatch = false;
        }
      }, 2000);

      this.suggestionsShownEventDispatched = true;
    }

    this.checkOuterResults();
    // force the searchBox to open
    this.open();
  }

  /**
   * Closes the type-ahead searchBox.
   */
  override close(force?: boolean): void {
    super.close(force);

    this.suggestionsShownFirstTimeBeforeEventDispatch = false;
    this.suggestionsShownEventDispatched = false;
  }
}
